import { render, staticRenderFns } from "./PreviewDocumentLink.vue?vue&type=template&id=61b31efb&scoped=true"
import script from "./PreviewDocumentLink.vue?vue&type=script&lang=js"
export * from "./PreviewDocumentLink.vue?vue&type=script&lang=js"
import style0 from "./PreviewDocumentLink.vue?vue&type=style&index=0&id=61b31efb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b31efb",
  null
  
)

export default component.exports